<template>
  <div class="layout">
    <header class="clearfix">
      <nav class="navbar navbar-default" role="navigation" @mouseleave="close">
        <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle" @click="openNav()">
              <span class="sr-only">切换导航</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="javascript:;" style="width: 180px">
              <img style="width: 100%" src="@/assets/logo.png" />
            </a>
          </div>
          <div class="collapse navbar-collapse" id="example-navbar-collapse">
            <ul class="nav navbar-nav">
              <li @click="remove()">
                <router-link :to="{ path: '/' }">首页</router-link>
              </li>
              <li class="dropdown">
                <a
                  href="javascript:;"
                  class="dropdown-toggle only_act"
                  data-toggle="dropdown"
                  id="add"
                >
                  产品中心
                  <b class="caret"></b>
                </a>
                <ul class="dropdown-menu nav-production-body">
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/encoder' }">
                      编转码系统</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/broadcast' }"
                      >播出系统</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/contentProduction' }"
                      >内容生产系统</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/streamMedia' }"
                      >流媒体系统</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/live' }"
                      >直播一体机</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/screen' }">扩展屏</router-link>
                  </li>
                  <!-- <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/sandBox' }"
                      >电子沙盘</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/virtualStudio' }"
                      >XR虚拟演播室</router-link
                    >
                  </li> -->
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/NetworkTesting' }"
                      >网络测试系统</router-link
                    >
                  </li>
                  <li @click="add()">
                    <i></i
                    ><router-link :to="{ path: '/Agent' }"
                      >多智能体平台</router-link
                    >
                  </li>
                </ul>
              </li>
              <li @click="remove()">
                <router-link :to="{ path: '/media' }">公司动态</router-link>
              </li>
              <li @click="remove()">
                <router-link :to="{ path: '/cases' }">行业客户</router-link>
              </li>
              <li @click="remove()">
                <router-link :to="{ path: '/about' }">关于我们</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-show="show"
          style="position: fixed; z-index: 3; top: 0px; width: 100%"
        >
          <div class="container">
            <div
              class="navbar-header"
              style="background-color: rgba(14, 10, 10, 0.87)"
            >
              <button type="button" class="navbar-toggle" @click="openNav()">
                <span class="sr-only">切换导航</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" href="javascript:;">
                <img src="@/assets/logo1.png" />
              </a>
            </div>
          </div>
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @select="close"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <router-link :to="{ path: '/' }"
              ><el-menu-item index="/">
                <span slot="title">首页</span>
              </el-menu-item>
            </router-link>
            <el-submenu index="2">
              <template slot="title">
                <span>产品中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/encoder">
                  <i></i>
                  <router-link :to="{ path: '/encoder' }"
                    >编转码系统</router-link
                  ></el-menu-item
                >

                <el-menu-item index="/broadcast">
                  <i></i
                  ><router-link :to="{ path: '/broadcast' }"
                    >播出系统</router-link
                  ></el-menu-item
                >

                <el-menu-item index="/contentProduction"
                  ><i></i>
                  <router-link :to="{ path: '/contentProduction' }"
                    >内容生产系统</router-link
                  ></el-menu-item
                >

                <el-menu-item index="/streamMedia">
                  <i></i
                  ><router-link :to="{ path: '/streamMedia' }"
                    >流媒体系统</router-link
                  ></el-menu-item
                >

                <el-menu-item index="/live">
                  <i></i>
                  <router-link :to="{ path: '/live' }"
                    >直播一体机
                  </router-link></el-menu-item
                >

                <el-menu-item index="/screen">
                  <i></i>
                  <router-link :to="{ path: '/screen' }"
                    >扩展屏
                  </router-link></el-menu-item
                >

                <!-- <el-menu-item index="/sandBox">
                  <i></i>
                  <router-link :to="{ path: '/sandBox' }"
                    >电子沙盘</router-link
                  ></el-menu-item
                >

                <el-menu-item index="/virtualStudio">
                  <i></i
                  ><router-link :to="{ path: '/virtualStudio' }"
                    >XR虚拟演播室</router-link
                  ></el-menu-item
                > -->

                <el-menu-item index="/NetworkTesting">
                  <i></i
                  ><router-link :to="{ path: '/NetworkTesting' }"
                    >网络测试系统
                  </router-link></el-menu-item
                >
                <el-menu-item index="/Agent">
                  <i></i
                  ><router-link :to="{ path: '/Agent' }"
                    >多智能体平台
                  </router-link></el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <router-link :to="{ path: '/media' }">
              <el-menu-item index="3">
                <span slot="title">公司动态</span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ path: '/cases' }">
              <el-menu-item index="4">
                <span slot="title">行业客户</span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ path: '/about' }">
              <el-menu-item index="5">
                <span slot="title">关于我们</span>
              </el-menu-item>
            </router-link>
          </el-menu>
        </div>
      </nav>
    </header>
    <router-view />
    <footer
      class="visible-md visible-lg"
      style="margin-top: 20px; background-color: #fff"
    >
      <div class="container">
        <p class="col-sm-7 col-md-7 col-lg-7 visible-md visible-lg">
          <span class="footsize"
            >TEL:（087）010-82331879 FAX:(086)010-82331989</span
          ><br />
          <span class="footsize">EMAIL：bravo@bravovcloud.com</span><br />
          <span class="footsize"
            >ADD：北京市海淀区安宁庄西路9号院能+中心富地407室</span
          ><br />
          <router-link
            to="/privacy"
            tag="span"
            class="footsize"
            style="cursor: pointer"
            >隐私政策</router-link
          ><br />
        </p>
        <p
          class="col-sm-5 col-md-5 col-lg-5 visible-md visible-lg"
          style="text-align: right"
        >
          <span class="footsize"
            >Copyright © 2022 BRAVO观止创想，保留所有权利</span
          ><br />
          <span class="footsize" style="margin-top: 20px; display: inline-block"
            >京ICP备18001475</span
          ><br />
        </p>
      </div>
      <p style="text-align: center; margin-top: 80px">
        <img src="@/assets/11.png" alt="Footer Logo" />
        <span
          style="color: rgb(147, 147, 147); font-size: 15px; margin-left: 10px"
          >京公网安备 11010802042930号</span
        >
      </p>
    </footer>
    <footer
      class="visible-xs visible-sm"
      style="margin-top: 20px; background-color: #fff"
    >
      <div class="container">
        <p class="col-sm-12 col-md-12 col-lg-12 visible-sm visible-xs">
          <span class="footsize" style="margin-top: 10px; display: inline-block"
            >TEL:（087）010-82331879 FAX:(086)010-82331989</span
          ><br />
          <span class="footsize" style="margin-top: 10px; display: inline-block"
            >EMAIL：bravo@bravovcloud.com</span
          ><br />
          <span class="footsize" style="margin-top: 10px; display: inline-block"
            >ADD：北京市海淀区安宁庄西路9号院金泰富地大厦407室</span
          ><br />
          <span class="footsize" style="margin-top: 10px; display: inline-block"
            >Copyright © 2022 BRAVO观止创想，保留所有权利</span
          ><br />
          <span class="footsize" style="margin-top: 10px; display: inline-block"
            >京ICP备18001475</span
          ><br />
        </p>
      </div>
    </footer>
    <!-- <div style="height: 1000px; width: 100%"></div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex2: '1',
      show: false
    }
  },
  mounted () {
    this.openNav()
    this.close()
  },
  methods: {
    openNav () {
      this.show = !this.show
    },
    close () {
      this.show = false
    },
    add () {
      var dom = document.getElementById("add")
      dom.classList.add("active")
    },
    remove () {
      var dom = document.getElementById("add")
      dom.classList.remove("active")
    }

  }
}
</script>

<style  lang='less'>
.dropdown-toggle[aria-expanded="true"] {
  color: #0080cc;
  border-bottom: 1px solid #0080cc;
  background-color: #fff;
}

.navbar-default .navbar-nav > li > a.active {
  color: #0080cc;
  border-bottom: 1px solid #0080cc;
  background-color: #fff;
}

header .navbar-default .navbar-nav > li > a:not(.active):hover {
  color: #0080cc;
  border-bottom: 7px solid #0080cc;
  background-color: #fff;
}
header .navbar-default .navbar-nav > li > a:focus,
.navbar-default .navbar-nav > li > a:focus {
  color: #0080cc;
  border-bottom: 7px solid #0080cc;
  background-color: #fff;
  outline: none;
}
.footer {
  min-height: 200px;
}
a:hover {
  text-decoration: none;
}
.el-menu {
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.2) !important;
  .el-menu-item-group {
    li i {
      width: 24px;
      height: 24px;
      float: left;
      margin: 15px 10px 0 20px;
      background: url("../assets/index/center_icon.png") no-repeat;
      background-blend-mode: lighten;
    }

    li a:hover {
      text-decoration: none;
    }
    li:nth-of-type(1) i {
      background-position: -8px -2px;
    }
    li:nth-of-type(2) i {
      background-position: -39px -2px;
    }
    li:nth-of-type(3) i {
      background-position: -69px -2px;
    }
    li:nth-of-type(4) i {
      background-position: -99px -2px;
    }
    li:nth-of-type(5) i {
      background: url("../assets/index/5938.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(7) i {
      background: url("../assets/index/m_sandBox_icon.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(8) i {
      background: url("../assets/index/11259.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(9) i {
      background: url("../assets/index/1125.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(10) i {
      background: url("../assets/index/m_agent_icon.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(6) i {
      background: url("../assets/index/11377.png") no-repeat;
      background-size: 100% 100%;
    }
    li:nth-of-type(1):hover i {
      background-position: -8px -32px;
    }
    li:nth-of-type(2):hover i {
      background-position: -39px -32px;
    }
    li:nth-of-type(3):hover i {
      background-position: -69px -32px;
    }
    li:nth-of-type(4):hover i {
      background-position: -99px -32px;
    }

    li a:hover {
      color: #428bca;
      text-decoration: none;
    }
    li:hover a {
      color: #428bca;
    }
    li {
      background-color: rgba(0, 0, 0, 0.7) !important;
    }
  }
  .el-menu-item {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .el-menu-item:hover {
    background-color: #000 !important;
    span {
      color: #428bca;
    }
  }

  .el-submenu {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .el-submenu__title:hover {
    background-color: #000 !important;
    span {
      color: #428bca;
    }
  }
  .el-submenu__title {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .el-menu-item-group__title {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .el-menu-item-group > ul .el-menu-item {
    background-color: rgba(0, 0, 0, 0.1) !important;
    a {
      color: #fff;
    }
  }
  .el-menu-item-group > ul li:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
    a {
      color: #428bca !important;
    }
  }
}
</style>
